import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom"; // Use Navigate, Route, and RouteProps from 'react-router-dom'
import { auth } from "../services/firebaseAuth";
import { saveRedirectUrl } from "../utils/redirectUtils";

interface ProtectedRouteProps {}

const ProtectedRoute: React.FC<ProtectedRouteProps> = () => {
  const [user, loading, error] = useAuthState(auth);
  const location = useLocation();

  if (loading) {
    // Show loading indicator while authentication is in progress
    return <div>Loading...</div>;
  }

  if (error) {
    // Handle authentication error
    console.error("Authentication error:", error);
    return <div>Authentication error</div>;
  }

  if (!user) {
    // Ne pas sauvegarder les URLs de login/signup comme URL de redirection
    const isAuthPage =
      location.pathname === "/login" ||
      location.pathname === "/signup" ||
      location.pathname === "/reset-password" ||
      location.pathname === "/confirm-reset-password";

    if (!isAuthPage) {
      // Sauvegarder l'URL demandée avant de rediriger vers login
      saveRedirectUrl(location.pathname, location.search);
    }
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
